import useSWR from 'swr';

const useFetchWithCondition = (key, fetcher, condition) =>
  useSWR(condition ? key : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

export default useFetchWithCondition;
